import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import StackViewer from '../components/organ-segmentation/StackViewer';
import MeshViewer from '../components/organ-segmentation/MeshViewer';
import './OrganSegmentationViewerPopout.css';

/**
 * Standalone viewer page for pop-out windows
 * 
 * Query params:
 * - organ: organ key (e.g., 'spleen' or 'liver_heart_spleen')
 * - sliceInfo: encoded JSON for stack viewer (optional)
 * - isDemo: 'true' to load from S3 demo data (optional, default: false)
 */
const OrganSegmentationViewerPopout = () => {
  const [searchParams] = useSearchParams();
  const organ = searchParams.get('organ');
  const sliceInfoParam = searchParams.get('sliceInfo');
  const isDemoParam = searchParams.get('isDemo');
  
  const [sliceInfo, setSliceInfo] = useState(null);
  const isDemo = isDemoParam === 'true';

  useEffect(() => {
    if (sliceInfoParam) {
      try {
        setSliceInfo(JSON.parse(decodeURIComponent(sliceInfoParam)));
      } catch (e) {
      }
    }
  }, [sliceInfoParam]);

  if (!organ) {
    return (
      <div className="viewer-popout-error">
        <h2>❌ Invalid Viewer Parameters</h2>
        <p>Missing required parameter: organ</p>
      </div>
    );
  }

  return (
    <div className="viewer-popout">
      <div className="viewer-popout-header">
        <h1 className="viewer-popout-title">
          Scan DeepView
        </h1>
        <div className="viewer-popout-subtitle">
          Organ: <strong>{organ}</strong>
        </div>
      </div>

      <div className="viewer-popout-content">
        <div className="viewer-popout-grid">
          <div className="viewer-popout-section">
            <h3 className="viewer-popout-section-title">3D Mesh</h3>
            <MeshViewer organ={organ} isDemo={isDemo} />
          </div>
          <div className="viewer-popout-section">
            <h3 className="viewer-popout-section-title">2D Stack</h3>
            <StackViewer organ={organ} sliceInfo={sliceInfo} isDemo={isDemo} />
          </div>
        </div>
      </div>

      <div className="viewer-popout-footer">
        <small className="text-muted">
          Scan DeepView • Close this window to return to main page
        </small>
      </div>
    </div>
  );
};

export default OrganSegmentationViewerPopout;

